import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment, createBlock as _createBlock, renderList as _renderList, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "app-goal-detail"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("目标管理");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("目标详情");

const _hoisted_4 = {
  class: "basic"
};
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = {
  class: "item"
};

const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "目标名称：", -1);

const _hoisted_8 = {
  class: "item"
};

const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "目标商品：", -1);

const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  key: 0,
  class: "item"
};

const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "目标销量：", -1);

const _hoisted_14 = {
  class: "item"
};

const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "目标金额：", -1);

const _hoisted_16 = {
  class: "item"
};

const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "考核指标：", -1);

const _hoisted_18 = {
  class: "item"
};

const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "考核团队：", -1);

const _hoisted_20 = {
  class: "item"
};

const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "考核周期：", -1);

const _hoisted_22 = {
  key: 0
};
const _hoisted_23 = {
  key: 1
};
const _hoisted_24 = {
  class: "item"
};

const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "达成奖励：", -1);

const _hoisted_26 = {
  class: "progress"
};
const _hoisted_27 = {
  class: "progress-info"
};
const _hoisted_28 = {
  class: "member-process"
};
const _hoisted_29 = {
  class: "title"
};
const _hoisted_30 = {
  style: {
    "color": "#999"
  }
};
const _hoisted_31 = {
  style: {
    "color": "#999"
  }
};
const _hoisted_32 = {
  style: {
    "color": "#999"
  }
};
const _hoisted_33 = {
  style: {
    "color": "#999"
  }
};
const _hoisted_34 = {
  key: 0
};
import { ref, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import { get } from 'lodash-es';
import { targetDetail, taskUserRecord } from '@/request';
import Tool from '@/utils/tool';
export default {
  name: 'detail',

  setup(__props) {
    const route = useRoute();
    onMounted(() => getDetail());
    const img = ref('https://wyc-fe-static.yun-sk.com/static/wyt/web-logo-big.png');
    const detail = ref({});
    const loading = ref(true);

    function getDetail() {
      targetDetail({
        targetId: route.query.targetId
      }).then(res => {
        if (!res.success) return;
        let data = res.data;

        if (data.targetUserProcessVos && data.assessPeriod == 1) {
          // 年度分布
          data.targetUserProcessVos.forEach(item => {
            for (let i = 1; i < 13; i++) {
              item[`month_${i}`] = item.targetUserVoList.find(v => v.month == i);
            }
          });
        }

        data.finishSales = get(data, 'targetUserProcessVos', []).map(v => parseFloat(v.finishSalesTotal)).reduce((pre, cur) => pre + cur);
        detail.value = data;
      }).finally(() => loading.value = false);
    }

    const suppliersName = computed(() => {
      let teamList = detail.value.teamJson && JSON.parse(detail.value.teamJson);
      if (!teamList || (teamList === null || teamList === void 0 ? void 0 : teamList.length) == 0) return; // console.log(teamList)

      let str = '';
      let levelTypeList = ['0', '1', '2'];
      levelTypeList.forEach(levelType => {
        str += teamList.filter(v => v.levelType == levelType).map(v => v.text).join();

        if (levelType != '2') {
          str += '__';
        }
      });
      return str;
    });
    const finishPercentage = computed(() => {
      let {
        targetSales,
        finishSales
      } = detail.value;
      let result = finishSales / parseFloat(targetSales) * 100;

      if (result == 0) {
        return 0;
      }

      return result.toFixed(2);
    });
    const taskTypeText = computed(() => {
      if (detail.value.targetType == 1) {
        return '销量';
      }

      return '销售额';
    });

    function getImages(imgStr) {
      if (!imgStr) return;
      return imgStr.split(',');
    }

    const table = ref([]);
    const processModalShow = ref(false);

    function checkUserDetail(row) {
      let params = {
        supUserId: row.supUserId,
        targetId: detail.value.targetId
      };
      taskUserRecord(params).then(res => {
        if (!res.success) return;
        table.value = res.data;
        processModalShow.value = true;
      });
    }

    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");

      const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");

      const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");

      const _component_el_progress = _resolveComponent("el-progress");

      const _component_el_card = _resolveComponent("el-card");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_image = _resolveComponent("el-image");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_breadcrumb, {
        separator: "/"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_createVNode(_component_router_link, {
            to: {
              name: 'goal'
            }
          }, {
            default: _withCtx(() => [_hoisted_2]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never",
        class: "detail"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(detail.value.targetType == 1 ? '销量目标' : '销售额目标'), 1), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("span", null, _toDisplayString(detail.value.targetName), 1)]), _createElementVNode("div", _hoisted_8, [_hoisted_9, detail.value.targetProd == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_10, "全部商品")) : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(detail.value.targetProds && detail.value.targetProds.map(v => v.prodName).join('，')), 1))]), detail.value.targetType == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_hoisted_13, _createElementVNode("span", null, _toDisplayString(_unref(Tool).formatNumber(detail.value.targetSales)), 1)])) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("span", null, "¥" + _toDisplayString(_unref(Tool).formatNumber(detail.value.targetSales)), 1)]), _createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("span", null, _toDisplayString(detail.value.assessKpiAmount == 1 ? '订单金额(不含运费)' : '商品底价(未设置商品底价即计算为0)'), 1)])], 64)), _createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("span", null, _toDisplayString(_unref(suppliersName)), 1)]), _createElementVNode("div", _hoisted_20, [_hoisted_21, detail.value.assessPeriod == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(detail.value.year) + "年", 1)) : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_unref(Tool).formatTime(detail.value.startTime)) + "~" + _toDisplayString(_unref(Tool).formatTime(detail.value.endTime)), 1))]), _createElementVNode("div", _hoisted_24, [_hoisted_25, _createElementVNode("span", null, _toDisplayString(detail.value.rewardDesc || '无'), 1)])]), _createElementVNode("div", _hoisted_26, [_createVNode(_component_el_progress, {
          type: "circle",
          percentage: _unref(finishPercentage)
        }, null, 8, ["percentage"]), _createElementVNode("div", _hoisted_27, [_createElementVNode("p", null, "目标" + _toDisplayString(_unref(taskTypeText)) + "：" + _toDisplayString(_unref(Tool).formatNumber(detail.value.targetSales)), 1), _createElementVNode("p", null, "实际" + _toDisplayString(_unref(taskTypeText)) + "：" + _toDisplayString(_unref(Tool).formatNumber(detail.value.finishSales)), 1)])])]),
        _: 1
      }), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, "团队成员进度详情（共" + _toDisplayString(_unref(get)(detail.value, 'targetUserProcessVos.length')) + "人）", 1), detail.value.assessPeriod == 2 ? (_openBlock(), _createBlock(_component_el_table, {
        key: 0,
        data: detail.value.targetUserProcessVos || [],
        "max-height": "600px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "团队成员",
          prop: "linkMan"
        }), _createVNode(_component_el_table_column, {
          label: "目标值",
          prop: "targetSalesTotal"
        }), _createVNode(_component_el_table_column, {
          label: "实际完成",
          prop: "finishSalesTotal"
        }), _createVNode(_component_el_table_column, {
          label: "整体进度",
          prop: "processTotal"
        })]),
        _: 1
      }, 8, ["data"])) : (_openBlock(), _createBlock(_component_el_table, {
        key: 1,
        data: detail.value.targetUserProcessVos || [],
        "max-height": "600px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "团队成员",
          fixed: "",
          width: "100",
          prop: "linkMan"
        }), _createVNode(_component_el_table_column, {
          label: "目标值/实际完成/整体进度",
          width: "195",
          align: "center"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", _hoisted_30, _toDisplayString(_unref(Tool).formatNumber(scope.row.targetSalesTotal)), 1), _createTextVNode(" / " + _toDisplayString(_unref(Tool).formatNumber(scope.row.finishSalesTotal)) + " / ", 1), _createElementVNode("span", _hoisted_31, _toDisplayString(scope.row.processTotal), 1)]),
          _: 1
        }), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, i => {
          return _createVNode(_component_el_table_column, {
            label: `${i}月 目标/实际完成/整体进度`,
            width: "215",
            align: "center"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", _hoisted_32, _toDisplayString(_unref(Tool).formatNumber(scope.row[`month_${i}`].targetSales)), 1), _createTextVNode(" / " + _toDisplayString(_unref(Tool).formatNumber(scope.row[`month_${i}`].finishedSales)) + " / ", 1), _createElementVNode("span", _hoisted_33, _toDisplayString(scope.row[`month_${i}`].progress), 1)]),
            _: 2
          }, 1032, ["label"]);
        }), 64))]),
        _: 1
      }, 8, ["data"]))]), _createVNode(_component_el_dialog, {
        modelValue: processModalShow.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => processModalShow.value = $event),
        title: "完成详情",
        width: "700px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table, {
          data: table.value
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "客户名称",
            prop: "custName"
          }), _createVNode(_component_el_table_column, {
            label: "完成时间",
            prop: "overTime"
          }), _createVNode(_component_el_table_column, {
            label: "图片"
          }, {
            default: _withCtx(scope => [scope.row.pictureUrls ? (_openBlock(), _createElementBlock("div", _hoisted_34, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.pictureUrls.split(','), (url, index) => {
              return _openBlock(), _createBlock(_component_el_image, {
                src: url,
                style: {
                  "width": "90px",
                  "height": "90px",
                  "margin-right": "10px"
                },
                previewSrcList: getImages(scope.row.pictureUrls),
                "initial-index": index
              }, null, 8, ["src", "previewSrcList", "initial-index"]);
            }), 256))])) : _createCommentVNode("", true)]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])]),
        _: 1
      }, 8, ["modelValue"])])), [[_directive_loading, loading.value]]);
    };
  }

};